import { Trans } from '@mbarzda/solid-i18next'
import { type Component } from 'solid-js'
import WebinarPurchaseButtonB from './WebinarPurchaseButtonB'

const WebinarHeadlineB: Component<{ showCheckout: () => void }> = (props) => {
  return (
    <div class="lg:max-w-[925px] flex flex-col gap-8 text-white mb-6 xl:mb-14 text-center xl:text-left">
      <div class='flex flex-col gap-4'>
          <span class="text-white font-bold font-poppins text-3xl sm:text-4xl xl:text-5xl leading-tight xl:leading-[56px]">
            <Trans key='ls_webinar_headline' />
          </span>
          <div class="flex flex-col">
            <span class="text-maize-400 font-bold font-poppins text-base sm:text-xl">
              <Trans key='ls_webinar_headline_description' />
            </span>
            <span class="text-white font-normal font-poppins text-base sm:text-xl">
              <Trans key='ls_webinar_headline_description_2' />
            </span>
          </div>
      </div>
      <div class='flex justify-center xl:justify-start'>
        <div class='flex flex-col gap-2'>
          <WebinarPurchaseButtonB showCheckout={props.showCheckout} />
          <span class="text-white/60 font-inter text-sm text-center">Available for new accounts only</span>
        </div>
      </div>
    </div>
  )
}

export default WebinarHeadlineB
